import { createSlice } from '@reduxjs/toolkit';
import { PayslipState } from './payslipTypes';
import {
  createPayslip,
  fetchPayslips,
  fetchPayslipById,
  updatePayslip,
  deletePayslip,
  fetchPayslipsByEmployeeId
} from './payslipActions';

const initialState: PayslipState = {
  payslips: [],
  payslipsByEmployee: undefined,
  selectedPayslip: undefined,
  loading: false,
  error: undefined,
};

const payslipSlice = createSlice({
  name: 'payslip',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Payslip
      .addCase(createPayslip.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createPayslip.fulfilled, (state, action) => {
        state.loading = false;
        state.payslips.push(action.payload);
      })
      .addCase(createPayslip.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Payslips
      .addCase(fetchPayslips.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchPayslips.fulfilled, (state, action) => {
        state.loading = false;
        state.payslips = action.payload;
      })
      .addCase(fetchPayslips.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Payslip by ID
      .addCase(fetchPayslipById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchPayslipById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedPayslip = action.payload;
      })
      .addCase(fetchPayslipById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // by employee
      .addCase(fetchPayslipsByEmployeeId.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchPayslipsByEmployeeId.fulfilled, (state, action) => {
        state.loading = false;
        state.payslipsByEmployee = action.payload.data;
      })
      .addCase(fetchPayslipsByEmployeeId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Payslip
      .addCase(updatePayslip.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updatePayslip.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.payslips.findIndex(payslip => payslip.id === action.payload.id);
        if (index !== -1) {
          state.payslips[index] = action.payload;
        }
      })
      .addCase(updatePayslip.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Payslip
      .addCase(deletePayslip.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deletePayslip.fulfilled, (state, action) => {
        state.loading = false;
        state.payslips = state.payslips.filter(payslip => payslip.id !== action.payload.id);
      })
      .addCase(deletePayslip.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default payslipSlice.reducer;
